export enum GlobalBannerTypesEnum {
  info = 'info',
  error = 'error',
}

export enum GlobalBannerStatesEnum {
  dismissed = 'dismissed',
  none = 'none',
}
